import { graphql } from 'gatsby';

import indexPageWrapper from '../components/IndexPage';

const indexPage = indexPageWrapper('overview');

export default indexPage;

/* eslint-disable no-undef */
export const pageQuery = graphql`
  query OverviewQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(filter: {frontmatter: {path: {regex: "/^\/overview/i" }}}) {
      edges {
        node {
          id
          html
          frontmatter {
            path
            title
            menuOrder
            bannerUrl
          }
        }
      }
    }
  }
`;
